import { useLayout } from "@/contexts/layout-context";
import { triggerHaptic } from "@/lib/haptic-feedback";
import type { Data } from "@/types/data";
import { Link } from "react-router-dom";

interface NavItemProps {
	data: Data;
	label: string;
	href: string;
	onClick?: () => void;
	className?: string;
}

export default function NavItem({
	data,
	label,
	href,
	onClick,
	className,
}: NavItemProps) {
	const { selectedLayout, isShowcaseMode } = useLayout();

	// No modo showcase, usa o layout selecionado; senão usa o do setup
	const layoutToCheck = isShowcaseMode ? selectedLayout : data.layout;

	const handleClick = () => {
		triggerHaptic("light");
		if (onClick) {
			onClick();
		}
	};

	// Verifica se é um link externo (http, https, mailto, tel, whatsapp)
	const isExternalLink =
		href &&
		(href.startsWith("http://") ||
			href.startsWith("https://") ||
			href.startsWith("mailto:") ||
			href.startsWith("tel:") ||
			href.startsWith("whatsapp:"));

	// Se for link externo, sempre usa <a> tag
	if (isExternalLink) {
		return (
			<a
				href={href}
				onClick={handleClick}
				target="_blank"
				rel="noopener noreferrer"
				className={className}
			>
				{label}
			</a>
		);
	}

	if (layoutToCheck === 1) {
		return (
			<Link to={`/${href}`} onClick={handleClick} className={className}>
				{label}
			</Link>
		);
	} else if (layoutToCheck === 2) {
		return (
			<a
				href={href ? `#${href}` : "#"}
				onClick={handleClick}
				className={className}
			>
				{label}
			</a>
		);
	}

	return (
		<Link to={`/${href}`} onClick={handleClick} className={className}>
			{label}
		</Link>
	);
}
